import { OnboardingStep } from 'further-types/lp/onboarding';
import { OnboardingCustomRequestType } from 'further-types/lp/onboarding-custom-request';
import { KycRequestProcess } from 'further-types/lp/kyc';
import { KybRequestProcess, KybRequest } from 'further-types/lp/kyb';

export const onboardingStepLabels = {
  [OnboardingStep.InvestorPortalView]: 'Investor portal view',
  [OnboardingStep.DataRoomView]: 'Data room view',
  [OnboardingStep.InvestorDetails]: 'Investor details',
  [OnboardingStep.InvestorClassification]: 'Investor classification',
  [OnboardingStep.TaxDeclarations]: 'Tax declarations',
  [OnboardingStep.KYCOrKYB]: 'KYC/KYB check',
  [OnboardingStep.DocumentSigning]: 'Document signing',
  [OnboardingStep.CommitmentConfirmation]: 'Commitment confirmation',
};

export const onboardingCustomRequestTypeLabels = {
  [OnboardingCustomRequestType.Text]: 'Text field',
  [OnboardingCustomRequestType.File]: 'File upload',
  [OnboardingCustomRequestType.TextAndFile]: 'Both',
  [OnboardingCustomRequestType.SectionTitle]: 'Section title',
};

export const kycRequestProcessLabels = {
  [KycRequestProcess.EKycOnly]: 'eKYC only',
  [KycRequestProcess.InformationRequestOnly]: 'Information request only',
  [KycRequestProcess.EKycAndInformationRequest]: 'eKYC and information request',
};

export const kybRequestProcessLabels = {
  [KybRequestProcess.SystemDefaultForm]: 'System default KYB form',
  [KybRequestProcess.CustomRequestForm]: 'Custom KYB request form',
  [KybRequestProcess.ThirdPartyRedirection]: 'Third party redirection',
};

export const kybRequestLabels = {
  [KybRequest.EntityConstitutionalDocuments]: {
    title: 'Entity constitutional documents',
    description:
      'Entity constitutional documents (articles, incorporation certificate, trust deed)',
  },
  [KybRequest.RegistryExtract]: {
    title: 'Registry extract',
    description:
      'Registry extract (e.g. official online print-out including URL and date, or a certified copy of a paper extract, if your entity is registered)',
  },
  [KybRequest.EntityGroupOwnershipDiagram]: {
    title: 'Entity group ownership diagram',
    description:
      'If full beneficial ownership is not clear from the above, a full entity group ownership diagram',
  },
};

export const kybOnboardingStepDescription =
  'To use a company, partnership, fund, trust or other legal entity to invest, we must first carry out Know Your Business checks. To do this, please submit your information below.';
